// src/routes/AppRoutes.jsx
// Centralized route configuration for the Quinternship application

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginScreen    from "../screens/auth/LoginScreen";
import RegisterScreen from "../screens/auth/RegisterScreen";
import DashboardScreen from "../screens/dashboard/DashboardScreen";
import InternshipsScreen from "../screens/internships/InternshipsScreen";
import MyApplicationsScreen from "../screens/applications/MyApplicationsScreen";
import PaymentScreen from "../screens/payments/PaymentScreen";
import PaymentHistoryScreen from "../screens/payments/PaymentHistoryScreen";
import ProfileScreen from "../screens/profile/ProfileScreen";

/**
 * AppRoutes — declares all application routes.
 * Extend this file as new screens are added.
 */
const AppRoutes = () => {
  return (
    <Routes>
      {/* Auth routes */}
      <Route path="/login"    element={<LoginScreen />}    />
      <Route path="/register" element={<RegisterScreen />} />

      {/* Main App Routes */}
      <Route path="/dashboard" element={<DashboardScreen />} />
      <Route path="/dashboard/internships" element={<InternshipsScreen />} />
      <Route path="/dashboard/my-applications" element={<MyApplicationsScreen />} />
      <Route path="/dashboard/payment/:applicationId" element={<PaymentScreen />} />
      <Route path="/dashboard/payment-history" element={<PaymentHistoryScreen />} />
      <Route path="/dashboard/profile" element={<ProfileScreen />} />

      {/* Default redirect */}
      <Route path="/"   element={<Navigate to="/login"    replace />} />
      <Route path="*"   element={<Navigate to="/login"    replace />} />
    </Routes>
  );
};

export default AppRoutes;
